/**
 * Opens the Ask Jade widget from anywhere on the site, e.g. My Bookings → "Chat about this stay".
 * The widget (JadeChatWidget) listens for this event; booking chats need the guest to be logged in.
 */
export const OPEN_JADE_CHAT_EVENT = 'jadecaps:open-chat';

export function openJadeChat({ bookingId = null } = {}) {
  try {
    window.dispatchEvent(new CustomEvent(OPEN_JADE_CHAT_EVENT, { detail: { bookingId } }));
  } catch {
    /* ignore */
  }
}
